import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { fetchBreedings } from "../../../api/breeding";
import { useAccountStorage } from "../../../hooks/useAccountStorage";
import { DashboardGrid } from "../dashboard/Dashboard";
import { setupWelcomePath } from "./setupRoutes";
import { isSetupResolved, markSetupResolved } from "./setupStorage";

/**
 * Accueil de l'espace éleveur : dashboard, ou parcours de mise en route si le compte est
 * vierge.
 *
 * Le drapeau court-circuite la vérification une fois la question tranchée — sans lui,
 * chaque retour sur le dashboard coûterait une requête. Le parcours ne concerne que le
 * type `breeder` : un collaborateur ne crée rien.
 */
export const BreederHome = () => {
  const { t } = useTranslation();
  const { getAccountStorage } = useAccountStorage();
  const eligible =
    getAccountStorage()?.type === "breeder" && !isSetupResolved();

  const [decision, setDecision] = useState<"checking" | "dashboard" | "setup">(
    eligible ? "checking" : "dashboard"
  );

  useEffect(() => {
    if (!eligible) return;

    let cancelled = false;
    fetchBreedings().then((result) => {
      if (cancelled) return;
      // Une erreur de chargement ne doit pas envoyer vers le parcours quelqu'un qui a déjà
      // des élevages : dans le doute, on montre le dashboard.
      if (result.error || result.breedings.length > 0) {
        markSetupResolved();
        setDecision("dashboard");
        return;
      }
      setDecision("setup");
    });

    return () => {
      cancelled = true;
    };
  }, [eligible]);

  if (decision === "checking") {
    return <div className="p-4">{t("loading")}</div>;
  }
  if (decision === "setup") {
    return <Navigate to={setupWelcomePath()} replace />;
  }
  return <DashboardGrid />;
};
